import { Link as MuiLink } from '@mui/material'
import { Link } from '@src/components/Link'
import HandleMarkup from '../HandleMarkup'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  textLink: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
}))

interface ProductCategoryProps {
  category: string
  url: string
}

const ProductCategory: React.FC<ProductCategoryProps> = ({ category, url }) => {
  const { classes } = useStyles()
  return (
    <Link href={url} passHref>
      <MuiLink color="secondary" className={classes.textLink}>
        <HandleMarkup value={category} />
      </MuiLink>
    </Link>
  )
}

export default ProductCategory
